/* eslint-disable import/prefer-default-export */
import GTM from '@/utils/Controllers/GTM/Constants';
import { push } from '@/utils/Controllers/GTM/Utils';

export const pushGtmContactUs = () => {
  push({
    event: GTM.EVENT.CONTACT_US,
    eventCategory: GTM.EVENT.CATEGORY.LOYALTY,
    eventAction: GTM.EVENT.ACTION.CONTACT_US,
    eventLabel: GTM.EVENT.LABEL.SENT,
  });
};
